import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { RiSettings5Fill } from "react-icons/ri";

// Import components
import CatalogueTopNav from "../new-service/CatalogueTopNav";
import FormSharingPopup from "./FormSharingPopup";
import { formService } from "../../_services/form.service";
import useWindowSize from "../new-service/useWindowSize";

// Import styles
import "./Forms.css";
import "../new-service/service.css";

// SVG Icons
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const FormIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const UsersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const AlertCircleIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const EmptyFormIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

const ShareIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

const DuplicateIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

const MoreVerticalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="19" r="1" />
  </svg>
);

const UnpublishIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const PublishIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);

const TemplateIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="18" x2="12" y2="12" />
    <line x1="9" y1="15" x2="15" y2="15" />
  </svg>
);

// Tab configuration for forms filtering
const formTabs = [
  { id: 'all', label: 'All Forms' },
  { id: 'active', label: 'Active' },
  { id: 'draft', label: 'Drafts' },
  { id: 'templates', label: 'Templates' },
];

/**
 * Forms component for managing client forms
 */
// Sort options for dropdown
const sortOptions = [
  { id: 'newest', label: 'Newest first' },
  { id: 'oldest', label: 'Oldest first' },
  { id: 'name', label: 'Name A-Z' },
];

const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const Forms = (props) => {
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  // State
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [formToDelete, setFormToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const [sortBy, setSortBy] = useState('newest');
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [formSettingsPopup, setFormSettingsPopup] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [selectedShareSetting, setSelectedShareSetting] = useState(1);
  const [copiedFormId, setCopiedFormId] = useState(null);
  const [addDropdownOpen, setAddDropdownOpen] = useState(false);
  const [mobileActionForm, setMobileActionForm] = useState(null);

  // Load forms from localStorage on mount
  useEffect(() => {
    loadForms();
    loadFormSettings();
  }, []);

  // Animate settings popup on show
  useEffect(() => {
    if (formSettingsPopup) {
      setAnimate(true);
    }
  }, [formSettingsPopup]);

  // Add/remove body class for modal blur
  useEffect(() => {
    if (formSettingsPopup) {
      document.body.classList.add('filter_modal_body');
    }
    return () => {
      document.body.classList.remove('filter_modal_body');
    };
  }, [formSettingsPopup]);

  const loadForms = () => {
    setLoading(true);
    formService.listForms({})
      .then((response) => {
        const data = response?.data?.responseData;
        if (data?.result) {
          setForms(data.result);
        } else {
          setForms([]);
        }
        if (data?.shareForm !== undefined) {
          setSelectedShareSetting(data.shareForm);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error loading forms:', error);
        setForms([]);
        setLoading(false);
      });
  };

  const loadFormSettings = () => {
    // Settings are now loaded alongside forms from the API
    // The shareForm value comes back in the list response
  };

  const handleSettingsClick = () => {
    setFormSettingsPopup(true);
  };

  const handleSettingsClose = () => {
    setAnimate(false);
    setTimeout(() => setFormSettingsPopup(false), 300);
  };

  const handleShareSettingApply = (value) => {
    setSelectedShareSetting(value);
  };

  // Navigation
  const openNewFormModal = () => {
    props.history.push('/forms/new');
  };

  // Roles & permissions (access audit 2026-10-02): the server says per form
  // whether this person may change it (its author; the salon's forms: the
  // owner or `catalogue`; never another self-employed stylist's). Older APIs
  // don't say — show as before.
  const canManage = (form) => !form || form.canManage !== false;

  // Edit form
  const editForm = (e, form) => {
    e.stopPropagation();
    props.history.push({
      pathname: '/forms/new',
      state: {
        formData: form.sections,
        formId: form._id || form.id,
        formSettings: form.settings,
        formName: form.name,
        formStatus: form.status,
        heroImage: form.heroImage || '',
        isTemplate: form.isTemplate || false,
        isEditing: true
      }
    });
  };

  // View form (preview)
  const viewForm = (form) => {
    props.history.push({
      pathname: '/forms/new',
      state: {
        formData: form.sections,
        formId: form._id || form.id,
        formSettings: form.settings,
        formName: form.name,
        formStatus: form.status,
        isTemplate: form.isTemplate || false,
        isEditing: true
      }
    });
  };

  // Duplicate form (or use template) — opens form builder as a NEW form with cloned data
  const duplicateForm = (e, form) => {
    e.stopPropagation();
    props.history.push({
      pathname: '/forms/new',
      state: {
        formData: form.sections,
        formSettings: form.settings,
        formName: (form.isTemplate ? '' : 'Copy of ') + (form.name || 'Untitled Form'),
        heroImage: form.heroImage || '',
        isEditing: false // new form, not editing the original
      }
    });
  };

  // Toggle form publish status (active <-> draft) directly from the table
  const toggleFormStatus = (e, form) => {
    e.stopPropagation();
    const formId = form._id || form.id;
    const newStatus = form.status === 'active' ? 'draft' : 'active';
    formService.editForm({
      formId,
      name: form.name,
      settings: form.settings,
      sections: form.sections,
      status: newStatus,
      isTemplate: form.isTemplate || false,
      heroImage: form.heroImage || ''
    }).then(() => {
      setForms(prev => prev.map(f =>
        (f._id || f.id) === formId ? { ...f, status: newStatus } : f
      ));
    }).catch((error) => {
      console.error('Error updating form status:', error);
    });
  };

  // Delete form
  const confirmDeleteForm = (e, form) => {
    e.stopPropagation();
    setFormToDelete(form);
    setShowDeleteModal(true);
  };

  const deleteForm = () => {
    if (formToDelete) {
      formService.deleteForm({ formId: formToDelete._id || formToDelete.id })
        .then(() => {
          const updatedForms = forms.filter(f => (f._id || f.id) !== (formToDelete._id || formToDelete.id));
          setForms(updatedForms);
          setShowDeleteModal(false);
          setFormToDelete(null);
        })
        .catch((error) => {
          console.error('Error deleting form:', error);
          setShowDeleteModal(false);
          setFormToDelete(null);
        });
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setFormToDelete(null);
  };

  const copyShareLink = (e, form) => {
    e.stopPropagation();
    const formId = form._id || form.id;
    const shareUrl = `${window.location.origin}/forms/fill/${formId}`;
    navigator.clipboard.writeText(shareUrl)
      .then(() => {
        setCopiedFormId(formId);
        setTimeout(() => setCopiedFormId(null), 2000);
      })
      .catch((err) => {
        console.error('Failed to copy link:', err);
        // Fallback: use a prompt
        window.prompt('Copy this link:', shareUrl);
      });
  };

  // Filter forms based on active tab
  const getFilteredForms = () => {
    let filtered = [...forms];

    // Filter by tab
    if (activeTab === 'active') {
      filtered = filtered.filter(f => f.status === 'active');
    } else if (activeTab === 'draft') {
      filtered = filtered.filter(f => f.status === 'draft' || !f.status);
    } else if (activeTab === 'templates') {
      filtered = filtered.filter(f => f.isTemplate);
    }

    // Filter by search
    if (searchQuery) {
      filtered = filtered.filter(f =>
        f.name?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Sort
    if (sortBy === 'newest') {
      filtered.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
    } else if (sortBy === 'oldest') {
      filtered.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
    } else if (sortBy === 'name') {
      filtered.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }

    return filtered;
  };

  const filteredForms = getFilteredForms();

  // Calculate stats
  const stats = {
    total: forms.length,
    active: forms.filter(f => f.status === 'active').length,
    draft: forms.filter(f => f.status === 'draft' || !f.status).length,
    responses: forms.reduce((sum, f) => sum + (f.responses || 0), 0)
  };

  // Get form type label
  const getFormTypeLabel = (form) => {
    const type = form.settings?.formType;
    if (type === 'automatic') return 'Automatic';
    if (type === 'manual') return 'Manual';
    return 'Standard';
  };

  return (
    <div className="h_n catalogue-no-header">
      <div className="body_container cm_bg_white">

        <div className="catalogue-page-wrapper">
          {/* Catalogue Top Navigation - Shared across Services, Products, Forms, etc. */}
          <CatalogueTopNav>
            <div className="forms-add-btn-wrapper">
              <button className="catalogue-add-btn" onClick={() => {
                const hasTemplates = forms.some(f => f.isTemplate);
                if (hasTemplates) {
                  setAddDropdownOpen(!addDropdownOpen);
                } else {
                  openNewFormModal();
                }
              }}>
                <PlusIcon />
                <span>Add</span>
              </button>
              {addDropdownOpen && (
                <>
                  <div className="forms-add-backdrop" onClick={() => setAddDropdownOpen(false)} />
                  <div className="forms-add-dropdown">
                    <button className="forms-add-dropdown-item" onClick={() => { setAddDropdownOpen(false); openNewFormModal(); }}>
                      <PlusIcon />
                      <span>Blank Form</span>
                    </button>
                    <button className="forms-add-dropdown-item" onClick={() => { setAddDropdownOpen(false); setActiveTab('templates'); }}>
                      <TemplateIcon />
                      <span>From Template</span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </CatalogueTopNav>

          {/* Forms Sub-Header with Filter Tabs */}
          <div className="forms-sub-header">
            <div className="forms-sub-header-container">
              <div className="forms-sub-header-content">
                {/* Left: Filter Tabs */}
                <nav className="forms-tabs-nav">
                  {formTabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`forms-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                    >
                      {tab.label}
                      {tab.id === 'active' && stats.active > 0 && (
                        <span className="forms-tab-badge">{stats.active}</span>
                      )}
                      {tab.id === 'draft' && stats.draft > 0 && (
                        <span className="forms-tab-badge draft">{stats.draft}</span>
                      )}
                    </button>
                  ))}
                </nav>

                {/* Right: Actions */}
                <div className="forms-header-actions">
                  <div className="forms-settings-btn" onClick={handleSettingsClick}>
                    <RiSettings5Fill />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="forms-main-container">
            <div className="forms-content-wrapper">
              {/* Main Card */}
              <div className="forms-table-container">
                {/* Card Header */}
                <div className="forms-card-header">
                  <div className="forms-card-title">
                    <h3>
                      {activeTab === 'all' ? 'All Forms' :
                       activeTab === 'active' ? 'Active Forms' :
                       activeTab === 'draft' ? 'Draft Forms' : 'Form Templates'}
                    </h3>
                    <span className="forms-count-badge">{filteredForms.length}</span>
                  </div>
                  <div className="forms-card-actions">
                    <div className="forms-search-input">
                      <SearchIcon />
                      <input
                        type="text"
                        placeholder="Search forms..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    <div className="forms-sort-dropdown">
                      <button
                        className="forms-sort-trigger"
                        onClick={() => setSortDropdownOpen(!sortDropdownOpen)}
                      >
                        <span>{sortOptions.find(o => o.id === sortBy)?.label}</span>
                        <svg
                          className={`forms-sort-chevron ${sortDropdownOpen ? 'open' : ''}`}
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M6 9l6 6 6-6" />
                        </svg>
                      </button>
                      {sortDropdownOpen && (
                        <>
                          <div
                            className="forms-sort-backdrop"
                            onClick={() => setSortDropdownOpen(false)}
                          />
                          <div className="forms-sort-menu">
                            {sortOptions.map((option) => (
                              <button
                                key={option.id}
                                className={`forms-sort-option ${sortBy === option.id ? 'active' : ''}`}
                                onClick={() => {
                                  setSortBy(option.id);
                                  setSortDropdownOpen(false);
                                }}
                              >
                                <span>{option.label}</span>
                                {sortBy === option.id && (
                                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M5 13l4 4L19 7" />
                                  </svg>
                                )}
                              </button>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Content */}
                {loading ? (
                  <div className="forms-loading-state">
                    <div className="forms-loading-spinner" />
                    <p className="forms-loading-text">Loading forms...</p>
                  </div>
                ) : filteredForms.length === 0 ? (
                  <div className="forms-empty-state">
                    <div className="forms-empty-icon">
                      <EmptyFormIcon />
                    </div>
                    <h3 className="forms-empty-title">
                      {searchQuery
                        ? 'No forms found'
                        : activeTab === 'all'
                          ? 'Create your first form'
                          : activeTab === 'active'
                            ? 'No active forms'
                            : activeTab === 'draft'
                              ? 'No draft forms'
                              : 'No templates yet'}
                    </h3>
                    <p className="forms-empty-text">
                      {searchQuery
                        ? 'Try adjusting your search to find what you\'re looking for.'
                        : activeTab === 'templates'
                          ? 'Save any form as a template to reuse it as a starting point for new forms.'
                          : 'Build custom intake forms, consultations, and consent forms to collect client information seamlessly.'}
                    </p>
                    {!searchQuery && (
                      <button className="forms-empty-btn" onClick={openNewFormModal}>
                        <PlusIcon />
                        Create New Form
                      </button>
                    )}
                  </div>
                ) : isMobile ? (
                  /* Mobile: Card-based list */
                  <>
                    <div className="forms-mobile-list">
                      {filteredForms.map((form, index) => (
                        <div
                          key={form._id || form.id || index}
                          className="forms-mobile-card"
                          onClick={() => viewForm(form)}
                        >
                          <div className="forms-mobile-card-left">
                            <div className="forms-icon">
                              <FormIcon />
                            </div>
                            <div className="forms-mobile-card-info">
                              <span className="forms-mobile-card-name">{form.name || 'Untitled Form'}</span>
                              <span className="forms-mobile-card-meta">
                                {getFormTypeLabel(form)}
                                <span className="forms-mobile-card-dot"> · </span>
                                <UsersIcon /> {form.responses || 0}
                              </span>
                            </div>
                          </div>
                          <div className="forms-mobile-card-right">
                            <span className={`forms-status ${form.status || 'draft'}`}>
                              {form.status === 'active' ? 'Active' :
                               form.status === 'completed' ? 'Completed' :
                               form.status === 'inactive' ? 'Inactive' : 'Draft'}
                            </span>
                            <button
                              className="forms-mobile-more-btn"
                              onClick={(e) => { e.stopPropagation(); setMobileActionForm(form); }}
                            >
                              <MoreVerticalIcon />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="forms-table-footer">
                      <span className="forms-table-info">
                        Showing {filteredForms.length} of {forms.length} forms
                      </span>
                    </div>

                    {/* Mobile Action Sheet */}
                    {mobileActionForm && (
                      <div className="forms-action-sheet-overlay" onClick={() => setMobileActionForm(null)}>
                        <div className="forms-action-sheet" onClick={(e) => e.stopPropagation()}>
                          <div className="forms-action-sheet-handle" />
                          <div className="forms-action-sheet-header">
                            <div className="forms-icon">
                              <FormIcon />
                            </div>
                            <div className="forms-action-sheet-title">
                              <span className="forms-action-sheet-name">{mobileActionForm.name || 'Untitled Form'}</span>
                              <span className="forms-action-sheet-meta">
                                {getFormTypeLabel(mobileActionForm)}
                                {mobileActionForm.isTemplate && ' · Template'}
                              </span>
                            </div>
                          </div>
                          <div className="forms-action-sheet-items">
                            {mobileActionForm.isTemplate && (
                              <button className="forms-action-sheet-item" onClick={(e) => { setMobileActionForm(null); duplicateForm(e, mobileActionForm); }}>
                                <TemplateIcon />
                                <span>Use Template</span>
                              </button>
                            )}
                            <button className="forms-action-sheet-item" onClick={() => { setMobileActionForm(null); viewForm(mobileActionForm); }}>
                              <EyeIcon />
                              <span>View</span>
                            </button>
                            {canManage(mobileActionForm) && <button className="forms-action-sheet-item" onClick={(e) => { setMobileActionForm(null); editForm(e, mobileActionForm); }}>
                              <EditIcon />
                              <span>Edit</span>
                            </button>}
                            <button className="forms-action-sheet-item" onClick={(e) => { setMobileActionForm(null); duplicateForm(e, mobileActionForm); }}>
                              <DuplicateIcon />
                              <span>Duplicate</span>
                            </button>
                            {!canManage(mobileActionForm) ? null : mobileActionForm.status === 'active' ? (
                              <button className="forms-action-sheet-item" onClick={(e) => { setMobileActionForm(null); toggleFormStatus(e, mobileActionForm); }}>
                                <UnpublishIcon />
                                <span>Unpublish</span>
                              </button>
                            ) : mobileActionForm.status !== 'completed' ? (
                              <button className="forms-action-sheet-item" onClick={(e) => { setMobileActionForm(null); toggleFormStatus(e, mobileActionForm); }}>
                                <PublishIcon />
                                <span>Publish</span>
                              </button>
                            ) : null}
                            {mobileActionForm.status !== 'active' && canManage(mobileActionForm) && (
                              <button className="forms-action-sheet-item delete" onClick={(e) => { setMobileActionForm(null); confirmDeleteForm(e, mobileActionForm); }}>
                                <TrashIcon />
                                <span>Delete</span>
                              </button>
                            )}
                          </div>
                          <button className="forms-action-sheet-cancel" onClick={() => setMobileActionForm(null)}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  /* Desktop: Table view */
                  <>
                    <div className="forms-table-wrapper">
                      <table className="forms-table">
                        <thead>
                          <tr>
                            <th>Form Name</th>
                            <th>Status</th>
                            <th>Responses</th>
                            <th>Created</th>
                            <th style={{ textAlign: 'right' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredForms.map((form, index) => (
                            <tr key={form._id || form.id || index} onClick={() => viewForm(form)}>
                              <td>
                                <div className="forms-name-cell">
                                  <div className="forms-icon">
                                    <FormIcon />
                                  </div>
                                  <div className="forms-name-text">
                                    <span className="forms-name">{form.name || 'Untitled Form'}</span>
                                    <span className="forms-type">{getFormTypeLabel(form)}</span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="forms-status-cell">
                                  <span className={`forms-status ${form.status || 'draft'}`}>
                                    {form.status === 'active' ? 'Active' :
                                     form.status === 'completed' ? 'Completed' :
                                     form.status === 'inactive' ? 'Inactive' : 'Draft'}
                                  </span>
                                  {form.isTemplate && (
                                    <span className="forms-status template">Template</span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <span className="forms-responses">
                                  <UsersIcon />
                                  {form.responses || 0}
                                </span>
                              </td>
                              <td>
                                <span className="forms-date">{form.createdAt ? new Date(form.createdAt).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'Just now'}</span>
                              </td>
                              <td>
                                <div className="forms-actions">
                                  {form.isTemplate ? (
                                    <button
                                      className="forms-action-btn use-template"
                                      onClick={(e) => duplicateForm(e, form)}
                                      title="Use this template"
                                    >
                                      <TemplateIcon />
                                      <span>Use</span>
                                    </button>
                                  ) : form.status === 'completed' ? (
                                    <button
                                      className="forms-action-btn view primary"
                                      onClick={(e) => { e.stopPropagation(); viewForm(form); }}
                                      title="View form"
                                    >
                                      <EyeIcon />
                                      <span>View</span>
                                    </button>
                                  ) : null}
                                  {form.status !== 'completed' && (
                                    <button
                                      className="forms-action-btn view"
                                      onClick={(e) => { e.stopPropagation(); viewForm(form); }}
                                      title="View form"
                                    >
                                      <EyeIcon />
                                      <span>View</span>
                                    </button>
                                  )}
                                  {!canManage(form) ? null : form.status === 'active' ? (
                                    <button
                                      className="forms-action-btn unpublish"
                                      onClick={(e) => toggleFormStatus(e, form)}
                                      title="Unpublish form"
                                    >
                                      <UnpublishIcon />
                                      <span>Unpublish</span>
                                    </button>
                                  ) : form.status !== 'completed' ? (
                                    <button
                                      className="forms-action-btn publish"
                                      onClick={(e) => toggleFormStatus(e, form)}
                                      title="Publish form"
                                    >
                                      <PublishIcon />
                                      <span>Publish</span>
                                    </button>
                                  ) : null}
                                  <button
                                    className="forms-action-btn duplicate"
                                    onClick={(e) => duplicateForm(e, form)}
                                    title="Duplicate form"
                                  >
                                    <DuplicateIcon />
                                    <span>Duplicate</span>
                                  </button>
                                  {canManage(form) && <button
                                    className="forms-action-btn edit"
                                    onClick={(e) => editForm(e, form)}
                                    title="Edit form"
                                  >
                                    <EditIcon />
                                    <span>Edit</span>
                                  </button>}
                                  {form.status !== 'active' && canManage(form) && (
                                    <button
                                      className="forms-action-btn delete"
                                      onClick={(e) => confirmDeleteForm(e, form)}
                                      title="Delete form"
                                    >
                                      <TrashIcon />
                                      <span>Delete</span>
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Table Footer */}
                    <div className="forms-table-footer">
                      <span className="forms-table-info">
                        Showing {filteredForms.length} of {forms.length} forms
                      </span>
                      {forms.length > 10 && (
                        <div className="forms-pagination-container">
                          <button className="forms-pagination-btn" disabled>
                            ‹
                          </button>
                          <button className="forms-pagination-btn active">1</button>
                          <button className="forms-pagination-btn" disabled>
                            ›
                          </button>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        {showDeleteModal && (
          <div className="forms-delete-modal-overlay" onClick={cancelDelete}>
            <div className="forms-delete-modal" onClick={(e) => e.stopPropagation()}>
              <div className="forms-delete-modal-icon">
                <AlertCircleIcon />
              </div>
              <h3>Delete Form</h3>
              <p>Are you sure you want to delete <strong>"{formToDelete?.name || 'this form'}"</strong>?</p>
              <p className="forms-delete-warning">This action cannot be undone.</p>
              <div className="forms-delete-modal-actions">
                <button className="btn btn-white" onClick={cancelDelete}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={deleteForm}>
                  Delete Form
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Form Sharing Settings Modal */}
        <Modal
          blurClass="blure_bg"
          centered
          show={formSettingsPopup}
          onHide={handleSettingsClose}
          backdropClassName="_light_bg"
          size="lg"
          dialogClassName={`bottom-modal ${animate ? 'slide-in' : 'slide-out'}`}
          className='_service__popup'
        >
          <Modal.Body>
            <div className="_filter">
              <h4>Form Settings</h4>
              <FormSharingPopup
                onHide={handleSettingsClose}
                onApply={handleShareSettingApply}
                selectedSetting={selectedShareSetting}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(Forms);
